export default __webpack_public_path__ + "static/media/3_long.1f0e7402.svg";